import React, { forwardRef } from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className = '',
  label,
  error,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-367" data-mp="1sbfczstmw22g">
        {label && <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-368" data-mp="1x7dx347xixx2">
            {label}
          </label>}
        <input ref={ref} className={`
            flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm placeholder:text-slate-400 
            focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
            ${className}
          `} {...props} data-id="element-369" data-mp="zm87g9vric7p" />
        {error && <p className="mt-1 text-sm text-red-500" data-id="element-370" data-mp="2oz24dcbuou91">{error}</p>}
      </div>;
});
Input.displayName = 'Input';